import type { JSX } from 'react';

import { Plus } from 'lucide-react';

import { Button } from '@/components/ui/button';
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from '@/components/ui/select';

import { AGENT_TEST_SCOPES, SCOPE_LABELS, type AgentTestScope } from '../../model/scenario';
import ScenarioCategoryField from './ScenarioCategoryField';

export type ScopeFilter = AgentTestScope | 'all';
export type EnabledFilter = 'all' | 'enabled' | 'disabled';

interface ScenariosToolbarProps {
  scope: ScopeFilter;
  enabled: EnabledFilter;
  tagInput: string;
  categories: string[];
  onScopeChange: (scope: ScopeFilter) => void;
  onEnabledChange: (enabled: EnabledFilter) => void;
  onTagInputChange: (tag: string) => void;
  onCreate: () => void;
}

const ScenariosToolbar = ({
  scope,
  enabled,
  tagInput,
  categories,
  onScopeChange,
  onEnabledChange,
  onTagInputChange,
  onCreate,
}: ScenariosToolbarProps): JSX.Element => (
  <div className="flex flex-wrap items-center gap-2">
    <Select value={scope} onValueChange={(value) => onScopeChange(value as ScopeFilter)}>
      <SelectTrigger className="w-[160px]" aria-label="Filtrar por alcance">
        <SelectValue placeholder="Alcance" />
      </SelectTrigger>
      <SelectContent>
        <SelectItem value="all">Todos los alcances</SelectItem>
        {AGENT_TEST_SCOPES.map((option) => (
          <SelectItem key={option} value={option}>
            {SCOPE_LABELS[option]}
          </SelectItem>
        ))}
      </SelectContent>
    </Select>

    <Select value={enabled} onValueChange={(value) => onEnabledChange(value as EnabledFilter)}>
      <SelectTrigger className="w-[160px]" aria-label="Filtrar por estado">
        <SelectValue placeholder="Estado" />
      </SelectTrigger>
      <SelectContent>
        <SelectItem value="all">Todos los estados</SelectItem>
        <SelectItem value="enabled">Habilitados</SelectItem>
        <SelectItem value="disabled">Deshabilitados</SelectItem>
      </SelectContent>
    </Select>

    <ScenarioCategoryField
      value={tagInput}
      categories={categories}
      onChange={onTagInputChange}
      placeholder="Filtrar por categoría…"
      ariaLabel="Filtrar por categoría"
      allowCreate={false}
      className="w-[200px]"
    />

    <div className="ml-auto">
      <Button type="button" onClick={onCreate}>
        <Plus className="size-4" aria-hidden />
        Nuevo escenario
      </Button>
    </div>
  </div>
);

export default ScenariosToolbar;
